"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatLists = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _utils = require("../../../../global-files/utils");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _CustomIcon = require("../../../atoms/CustomIcon");

var _Image = require("../../../atoms/Image");

var _Tooltip = require("../../../atoms/Tooltip");

var _jsxRuntime = require("react/jsx-runtime");

var ChatLists = function ChatLists(props) {
  var companies = props.companies,
      currentCompanyId = props.currentCompanyId,
      onClickCompany = props.onClickCompany;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      openChats = _useState2[0],
      setOpenChats = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      closedChats = _useState4[0],
      setClosedChats = _useState4[1];

  (0, _react.useEffect)(function () {
    renderChats();
  }, [companies]);

  var renderChats = function renderChats() {
    var jsxOpenChats = [];
    var jsxClosedChats = [];

    var _loop = function _loop() {
      var companyId = _Object$keys[_i];
      var company = companies[companyId]; // crear el item chat

      var itemChat = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContainerItemChat, {
        onClick: function onClick(event) {
          onClickCompany && onClickCompany(companyId);
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
          className: "img-logoCompany",
          width: "34px",
          sizeLoading: 24,
          colorLoading: undefined,
          src: company.src,
          componentDefault: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomIcon.CustomIcon, {
            className: "icon-logoCompany",
            type: "white",
            borderType: "circle",
            size: 15,
            icon: _freeSolidSvgIcons.faImage
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "container-info",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            className: "label-name",
            children: [" ", company.name, " "]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
            className: "label-lastDate",
            children: (0, _utils.getCustomDate)(new Date(company.items.length ? company.items[0].date : undefined))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-indicators",
          children: currentCompanyId === companyId && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "label-ownCompany",
            children: "Interno"
          })
        })]
      }, "itemChat-" + companyId); // checar si es chat abierto

      if (company.statusChat === "closed") jsxClosedChats.push(itemChat);else jsxOpenChats.push(itemChat);
    };

    for (var _i = 0, _Object$keys = Object.keys(companies); _i < _Object$keys.length; _i++) {
      _loop();
    }

    setOpenChats(jsxOpenChats);
    setClosedChats(jsxClosedChats);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      children: [openChats.length !== 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-headerChats",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
            className: "tooltip-title",
            position: "topCenter",
            addArrow: false,
            transitionType: "zoom",
            followCursor: false,
            componentTooltip: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContainerTooltip, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                className: "label-title",
                children: " Chats abiertos "
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                className: "label-message",
                children: "De acuerdo al estatus \n                  actual del producto, puedes establecer una conversaci\xF3n \n                  con estas compa\xF1ias"
              })]
            }),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              children: " Chats abiertos "
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-bodyChats",
          children: openChats
        })]
      }), closedChats.length !== 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-headerChats",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
            className: "tooltip-title",
            position: "topCenter",
            addArrow: false,
            transitionType: "zoom",
            followCursor: false,
            componentTooltip: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContainerTooltip, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                className: "label-title",
                children: " Chats cerrados "
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
                className: "label-message",
                children: "Las conversaciones \n                  con estas compa\xF1ias han finalizado debido al cambio de \n                  estatus, sigue el flujo de trabajo con tus chats abiertos"
              })]
            }),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              children: " Chats cerrados "
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-bodyChats",
          children: closedChats
        })]
      })]
    })
  });
};

exports.ChatLists = ChatLists;